import api from "../../../api/axios";

/**
 * =====================================================
 * GET USERS
 * =====================================================
 */

const getUsers = async (params = {}) => {
  const response = await api.get("/api/v1/power/users", {
    params,
  });

  return response.data;
};

/**
 * =====================================================
 * GET USER BY ID
 * =====================================================
 */

const getUserById = async (id) => {
  const response = await api.get(`/api/v1/power/users/${id}`);

  return response.data;
};

/**
 * =====================================================
 * CREATE USER
 * =====================================================
 */

const createUser = async (payload) => {
  const response = await api.post("/api/v1/power/users", payload);

  return response.data;
};

/**
 * =====================================================
 * UPDATE USER
 * =====================================================
 */

const updateUser = async ({ id, data }) => {
  const response = await api.patch(`/api/v1/power/users/${id}`, data);

  return response.data;
};

/**
 * =====================================================
 * UPDATE USER PERMISSIONS
 * =====================================================
 */

const updateUserPermissions = async ({ id, permissions }) => {
  const response = await api.patch(`/api/v1/power/users/${id}/permissions`, {
    permissions,
  });

  return response.data;
};

/**
 * =====================================================
 * CHANGE STATUS
 * =====================================================
 */

const changeUserStatus = async ({ id, status }) => {
  const response = await api.patch(`/api/v1/power/users/${id}/status`, {
    status,
  });

  return response.data;
};

/**
 * =====================================================
 * DISABLE USER
 * =====================================================
 */

const disableUser = async (id) => {
  const response = await api.patch(`/api/v1/power/users/${id}/disable`);

  return response.data;
};

/**
 * =====================================================
 * RESEND INVITE
 * =====================================================
 */

const resendSetupInvite = async (id) => {
  const response = await api.post(
    `/api/v1/power/users/${id}/resend-setup-invite`,
  );

  return response.data;
};

/**
 * =====================================================
 * GET ORGANIZATION COACHES
 * =====================================================
 */

const getOrganizationCoaches = async (organizationId) => {
  const response = await api.get(
    `/api/v1/power/organizations/${organizationId}/coaches`,
  );

  return response.data;
};

/**
 * =====================================================
 * EXPORT
 * =====================================================
 */

const userService = {
  getUsers,

  getUserById,

  createUser,

  updateUser,

  updateUserPermissions,

  changeUserStatus,

  disableUser,

  resendSetupInvite,

  getOrganizationCoaches,
};

export default userService;
